import { renderMessageBarTitle_unstable } from '@fluentui/react-message-bar';

/**
 * Renders the final JSX of the MessageBarTitle component, given the state.
 */
export const renderMessageBarTitle = renderMessageBarTitle_unstable;
